import { createAction } from 'redux-actions'

export const setBvId = createAction('TIRE_LINE/SET_BVID')

export const setTireSizeNumber = createAction('TIRE_LINE/SET_TIRE_SIZE_NUMBER')
